import React from 'react'
import { Routes, Route } from 'react-router-dom';

// Vistas
import Home from './home/Home';
import Err404 from './../error/404/Err404';
import About from './about/About';
import Categories from './categories/Categories';
import Category from './category/Category';
import Contact from './contact/Contact';
import Article from './article/Article';

export default function ModuleRoutes({ setPageTitle }: any) {
  return (
    <Routes>
      <Route path="/" element={
        <Home
          setPageTitle={setPageTitle}
        />
      } />

      <Route path="/acerca-de" element={
        <About
          setPageTitle={setPageTitle}
        />
      } />

      <Route path="/categorias" element={
        <Categories
          setPageTitle={setPageTitle}
        />
      } />

      <Route path="/contacto" element={
        <Contact
          setPageTitle={setPageTitle}
        />
      } />

      {/* Ruta dinámica para cada articulo */}
      <Route path="/a/:slug/:id?" element={
        <Article
          setPageTitle={setPageTitle}
        />
      } />

      {/* Ruta dinámica para cada articulo */}
      <Route path="/c/:title/:tag?" element={
        <Category
          setPageTitle={setPageTitle}
        />
      } />

      {/* Ruta de error 404 */}
      <Route path="*" element={
        <Err404
          setPageTitle={setPageTitle}
        />
      } />
    </Routes>
  )
}
